import React from "react";

const Textarea = ({ name, value, rows, required, disabled, label, error, onChange, hint }) => {
    return (
        <>
            <label htmlFor={`input-${name}`} className={`${required ? "input-required" : ""}`}>
                {label}
            </label>
            <textarea
                id={`input-${name}`}
                name={name}
                value={value}
                onChange={onChange}
                rows={rows}
                className={`input-disabled ${disabled ? "inactive" : ""}`}
                disabled={disabled}
            ></textarea>
            {hint && <div className="hint-message-text">{hint}</div>}
            {error && <div className="error-message-text">{error}</div>}
        </>
    );
};

export default Textarea;
